import { render } from "./IconEdit.vue?vue&type=template&id=99e4370e&scoped=true"
import script from "./IconEdit.vue?vue&type=script&lang=js"
export * from "./IconEdit.vue?vue&type=script&lang=js"

import "./IconEdit.vue?vue&type=style&index=0&id=99e4370e&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\ms\\ms-by-bimms\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-99e4370e"]])

export default __exports__